export default {
    getPressList(state) {
        return state.pressList;
    },
};